<footer class="px-5">
  <div class="link-list">
    <ul>
      <li>
        <a href="assets/docs/resi_privacy_policy.pdf" target="_blank">
          {{ 'footer.privacy_policy' | translate }}
        </a>
      </li>
      <li>
        <a href="assets/docs/resi_accessibility.pdf" target="_blank">{{ 'footer.accessibility' | translate }}</a>
      </li>
    </ul>
  </div>
</footer>
